module.exports = __webpack_public_path__ + "img/privacy_policy.aa74ac78.png";